import { Link } from "react-router-dom";
import '../styles/footer.css';
import {
  FaArrowRight,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaRocket,
  FaShieldAlt,
  FaTools,
} from "react-icons/fa";
import { getFooterCompanyLinks, getFooterServiceLinks } from "../content";

const serviceLinks = getFooterServiceLinks();
const companyLinks = getFooterCompanyLinks();

const deliveryHighlights = [
  { icon: FaRocket, label: "Ship modern websites and products" },
  { icon: FaTools, label: "Connect ecommerce, CRM, analytics, and tools" },
  { icon: FaShieldAlt, label: "Maintain performance, security, and reliability" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer site-footer" id="site-footer">
      <div className="site-footer__orb site-footer__orb--left" aria-hidden="true" />
      <div className="site-footer__orb site-footer__orb--right" aria-hidden="true" />

      <div className="site-footer__shell">
        <div className="site-footer__hero">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo" aria-label="Plux Infosystems home">
              <span>PL</span>
              <strong>Plux Infosystems</strong>
            </Link>
            <p>
              India-based web development and product engineering team for websites, ecommerce, AI automation,
              integrations, and long-term digital support.
            </p>
            <div className="site-footer__socials" aria-label="Social links">
              <a href="https://www.facebook.com/pluxinfosystems" target="_blank" rel="noreferrer" aria-label="Plux Infosystems on Facebook">
                <FaFacebookF aria-hidden="true" />
              </a>
              <a href="https://www.linkedin.com/company/plux-infosystems-private-limited" target="_blank" rel="noreferrer" aria-label="Plux Infosystems on LinkedIn">
                <FaLinkedinIn aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="site-footer__delivery-card" aria-label="Delivery strengths">
            <span className="site-footer__delivery-kicker">Delivery partner</span>
            <h2>Build, connect, optimize, and support your digital stack.</h2>
            <ul>
              {deliveryHighlights.map((item) => {
                const Icon = item.icon;
                return (
                  <li key={item.label}>
                    <Icon aria-hidden="true" />
                    <span>{item.label}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="site-footer__grid">
          <nav className="site-footer__links" aria-label="Footer services">
            <h3>Services</h3>
            <ul>
              {serviceLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>
                    {item.label}
                    <FaArrowRight aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="site-footer__links" aria-label="Footer company links">
            <h3>Company</h3>
            <ul>
              {companyLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>
                    {item.label}
                    <FaArrowRight aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__contact" aria-label="Contact details">
            <h3>Contact</h3>
            <a href="mailto:info@pluxinfosystems.com" className="site-footer__contact-card">
              <FaEnvelope aria-hidden="true" />
              <span>
                <strong>info@pluxinfosystems.com</strong>
                <small>Email or chat — no calls</small>
              </span>
            </a>
            <div className="site-footer__contact-card">
              <FaMapMarkerAlt aria-hidden="true" />
              <span>
                <strong>PLUX INFOSYSTEMS PVT. LTD.</strong>
                <small>135, Rajpuram, Chipiyana Buzurg, Gautam Buddha Nagar, Uttar Pradesh 201009</small>
              </span>
            </div>
          </div>
        </div>

        <div className="site-footer__bottom">
          <span>
            Copyright © {year} <Link to="/">PLUX INFOSYSTEMS PVT. LTD.</Link>
          </span>
          <button
            type="button"
            className="site-footer__back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Back to top"
          >
            Back to top <FaArrowRight aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;